import React, {useEffect, useState} from 'react';
import ModerationList from '../Cards/ModerationList';
import NotificationsList from '../Cards/NotificationsList';

const NotificationsModal = ({ isOpen, onClose, userId }) => {
   const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [activeTab, setActiveTab] = useState('moderation');
  const [selectedNotification, setSelectedNotification] = useState(null);
  const closeInfoPanel = () => {
    setSelectedNotification(null);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleHeaderClick = (e) => {
    closeInfoPanel();
  };


  if (!isOpen) return null;

  return (
    <div className={isMobile ? "modal-overlay-mobile" : "modal-overlay"} onClick={onClose}>
      <div
        className="modal fullscreen bottom-right open"
        onClick={handleModalClick}
      >
        <div className="modal-header" onClick={handleHeaderClick}>
          {isMobile && (
              <button className="modal-close-btn" onClick={onClose} aria-label="Закрыть">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          <div className="modal-tabs">
            <button
              className={`modal-tab-btn ${activeTab === 'moderation' ? 'active' : ''}`}
              onClick={() => setActiveTab('moderation')}
            >
              Модерация
            </button>
            <button
              className={`modal-tab-btn ${activeTab === 'notifications' ? 'active' : ''}`}
              onClick={() => setActiveTab('notifications')}
            >
              Уведомления
            </button>
          </div>
        </div>
          {activeTab === 'moderation' ? (
            <ModerationList selectedNotification={selectedNotification} setSelectedNotification={setSelectedNotification} closeInfoPanel={closeInfoPanel} isOpen={isOpen} userId={userId} />
          ) : (
            <NotificationsList isOpen={isOpen} userId={userId} />
          )}
      </div>
    </div>
  );
};

export default NotificationsModal;
